<template>
  <Modal :hideExit="true" cClass="mw424" @cancel="closeModal" classs="modal-create-campaign">
      <template #header>
        <p class="typo-heading20 typo-medium text-light-high">
          {{ $t("analytic.ab.createNewCamp") }}
        </p>
      </template>
      <template #default>
        <template>
          <div class="col-12 p-0">
            <div class="form-group">
              <p class="typo-paragraph14 typo-regular-150 text-light-low mb-1">{{ $t("analytic.ab.campTitle") }}</p>
              <input placeholder="Type Campaign's Name" v-focus ref="inputTitle" class="input-field input-field-block" type="text" v-model="campaignName" @keyup.enter="doSubmit" />
              <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">
                {{ alertText }}
              </p>
            </div>
          </div>
        </template>
      </template>
      <template #footer>
        <div class="btn-group flex-row-reverse">
          <button class="btn btn-primary ml-2" type="submit" @click="doSubmit">{{ $t("generals.next") }}</button>

          <button class="btn btn btn-outline" @click="closeModal">
            {{ $t("generals.cancel") }}
          </button>
        </div>
      </template>
    </Modal>
</template>

<script>

export default {
  name: "ModalGoogleSignin",
  components: {
  },
  props: {
    shop: String,
    template: [String, Number],
    plan: String,
  },
  data() {
    return {
      alertText: "",
      campaignName: "",
    };
  },
  computed: {
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    doSubmit() {
      if (!this.campaignName) {
        this.alertText = this.$t("error.blankName");
        return;
      }
      this.alertText = "";
      this.$emit("create", this.campaignName);
      this.campaignName = "";
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
